import React from 'react';

interface XIconProps {
  className?: string;
}

const XIcon: React.FC<XIconProps> = ({ className }) => (
  <i
    className={['fa-brands fa-x-twitter', className].filter(Boolean).join(' ')}
    aria-hidden="true"
  />
);

export default XIcon;
